// Человеческие названия аудит-событий — единый словарь для журнала аудита
// и виджета «Недавняя активность» (J-4: машинные коды вида
// document.bulk_signed на дашборде — язык разработчика, не пользователя).
export const ACTION_LABELS = {
  "auth.login": "Вход",
  "auth.logout": "Выход",
  "auth.signup": "Регистрация",
  "auth.password_changed": "Смена пароля",
  "auth.email_verified": "Email подтверждён",
  "org.updated": "Изменены настройки",
  "org.member_invited": "Приглашение отправлено",
  "org.member_invite_accepted": "Приглашение принято",
  "org.member_invite_revoked": "Приглашение отозвано",
  "org.member_role_changed": "Изменена роль",
  "org.member_removed": "Удалён участник",
  "document.uploaded": "Документ загружен",
  "document.updated": "Документ изменён",
  "document.deleted": "Документ удалён",
  "document.sent": "Документ отправлен",
  "document.signed": "Документ подписан",
  "document.bulk_signed": "Массовое подписание",
  "document.generated_from_template": "Документ из шаблона",
  "document.rejected": "Документ отклонён",
  "template.created": "Шаблон создан",
  "template.updated": "Шаблон обновлён",
  "template.deleted": "Шаблон удалён",
  "contractor.created": "Контрагент добавлен",
  "contractor.updated": "Контрагент изменён",
  "contractor.deleted": "Контрагент удалён",
  "form.created": "Форма создана",
  "form.updated": "Форма обновлена",
  "form.deleted": "Форма удалена",
  "form.published": "Форма опубликована",
  "form.unpublished": "Форма снята с публикации",
  "form.submitted": "Форма отправлена",
  "workflow.created": "Процесс создан",
  "workflow.updated": "Процесс обновлён",
  "workflow.published": "Процесс опубликован",
  "workflow.deleted": "Процесс удалён",
  "workflow.instance_started": "Запуск процесса",
  "workflow.instance_terminated": "Процесс прерван",
  "workflow.instance_errored": "Ошибка процесса",
  "task.created": "Задача создана",
  "task.claimed": "Задача взята в работу",
  "task.completed": "Задача выполнена",
  "task.override_completed": "Задача закрыта администратором",
  "settings.changed": "Настройки изменены",
  "api_key.created": "API-ключ создан",
  "api_key.revoked": "API-ключ отозван",
  "webhook.configured": "Webhook настроен",
  "webhook.deleted": "Webhook удалён",
};

export const labelForAction = (action) => ACTION_LABELS[action] || action;
